import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const StyledDeviceInfo = styled.div`
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px;
`;
